__turbopack_context__.v({
  "description": "HubspotFormWrapper-module__XCa74q__description",
  "form": "HubspotFormWrapper-module__XCa74q__form",
  "legal": "HubspotFormWrapper-module__XCa74q__legal",
  "overline": "HubspotFormWrapper-module__XCa74q__overline",
  "row": "HubspotFormWrapper-module__XCa74q__row",
  "text": "HubspotFormWrapper-module__XCa74q__text",
});
